import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {create_UUID, showAxiosError} from "../../util/Helpers";
import {API_BASE_URL} from "../../constants";
import './Payment.css';
import Table from "../../components/Table/Table";
import * as headerContent from "../../constants/exportcontent";
import Alert from "react-s-alert";

class AccrualStats extends Component {

    constructor(props) {
        super(props);

        this.state = {
            stats: [],
            statSums: [],
            transactionTypes: [],
            transactionChannels: [],
            cities: [],
            loading: false,
            searching: false,
            searchQuery: undefined,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
        };

        this.listStats = this.listStats.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    componentDidMount() {
        this.listStats();
    }

    listStats() {
        let self = this;
        let searchQuery = !self.state.searchQuery ? '' : '?' + self.state.searchQuery;
        let params = {
            url: API_BASE_URL + "/financial-transaction/fetchAccrualStatsByBranch/" + searchQuery,
            method: "get",
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                let stats = response.data;
                self.setState({
                    stats,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }


    handleSearch(searchQuery) {
        console.log("searchQuery", searchQuery);
        this.setState({
            searchQuery,
            searching: true
        }, () => this.listStats(this.state.accessor, this.state.direction, this.state.page, this.state.size))

    }

    arrangeDataSet() {
        let dataSet = {};
        dataSet.headers = headerContent.accrualStatsContent;
        dataSet.sheetName = 'Aidat İstatistikleri';
        dataSet.uuid = create_UUID();
        dataSet.accrualStats = this.state.stats;
        return dataSet;
    }

    async exportXls() {
        let self = this;
        let data = self.arrangeDataSet();
        let params = {
            url: API_BASE_URL + '/financial-transaction/downloadReportAccrualStats',
            method: "post",
            data: data,
        };
        Alert.success(
            "İndirme işleminiz sıraya alındı, İndirme işlemi tamamlandıktan sonra 'İNDİRME TALEPLERİNİZ'" +
            " butonuna tıklayarak excel dosyasını indirebilirsiniz.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 10000
            });
        await request(params).then(function (response) {
        }).catch(function (error) {
            showAxiosError(error);
        });
    }


    render() {

        const columns = [

            /*{
                Header: "İl",
                accessor: "city",
            },*/
            {
                Header: "Oda",
                accessor: "branch",
            },
            {
                Header: "Tip",
                accessor: "",
                Cell: item => (
                    <label>{item.type && item.type === "RegistrationFee" ? "Oda Kayıt Aidatı" : "Yıllık Aidat"}</label>)
            },
            {
                Header: "Yıl",
                accessor: "year",
            },
            {
                Header: "Tahsil Edilen",
                accessor: "payed",
            },
            {
                Header: "Tahsil Edilmeyen",
                accessor: "unPayed",
            },
            {
                Header: "Toplam",
                accessor: "total",
                Cell: item => (<label>{item.total.toFixed(2)}</label>)
            },
            {
                Header: "Tahsilat Yüzdesi",
                accessor: "percent",
                Cell: item => (<label>{"%" + item.percent.toFixed(2)}</label>)
            },
        ];

        const fields = [
            {
                label: "İlgili Yıl",
                accessor: "year",
                type: "text",
                operator: "=",
            },
        ];

        return (
            <div className="financial-transaction-list-container">
                <div className="row baseBackground">
                    <div className="col-md-12 satirBasi">
                        <div className="card-header ">
                            <h4 className="card-title">İktisadi İşletme Muhasebe Yönetimi</h4>
                        </div>
                        <div className="card-body mt-1">
                            <div className=" ">
                                <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                    <DetailedSearch fields={fields}
                                                    loading={this.state.searching}
                                                    onSearch={this.handleSearch}/>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <Table
                                loading={this.state.loading}
                                loadingText="Kayıtlar getiriliyor..."
                                content={this.state.stats}
                                total="10"
                                page="0"
                                manual={this.state.manual}
                                size="10"
                                columns={columns}
                                paginationEnabled={false}
                                fetchData={this.listStats}
                                style={{width:"100%"}}
                            />
                        </div>
                    </div>
                    <div className="new-button-holder">
                        <button type="button" data-toggle="tooltip" data-placement="bottom"
                                title="Excel İndir"
                                style={{
                                    background: 'linear-gradient(#129a30, #116128)',
                                    height: '40px',
                                    width: '155px',
                                    float: 'right',
                                    marginRight: '30px',
                                    color: 'white',
                                    borderRadius: '0.375em',
                                }}
                                rel="tooltip" className="TekBtn excel "

                                onClick={() => this.exportXls()}>
                            EXCEL İNDİR
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default AccrualStats;



// WEBPACK FOOTER //
// ./src/page/financial/AccrualStats.js